import { Badge, Column, Row, Typography } from '@viewup/ui';
import type { PostCampaignCardProps } from 'app/viewing/_entities/post';
import {
  PostCampaignCard,
  PostCampaignCardStatus,
  PostCampaignStatus,
  postCampaignStatusLabel,
} from 'app/viewing/_entities/post';

type SubmittedCardProps = PostCampaignCardProps & {
  applicationDate: string;
  earningPoint?: number;
  status: PostCampaignStatus.EARNING_SUCCESS | PostCampaignStatus.SUBMITTED;
};
export const SubmittedCard = (props: SubmittedCardProps) => {
  const { status, applicationDate, earningPoint } = props;

  return (
    <PostCampaignCard {...props}>
      <Badge colorVariant='blue' content={postCampaignStatusLabel[status]} variant='rectangle' />
      <PostCampaignCard.Progress status={PostCampaignCardStatus.SUBMITTED} />
      <PostCampaignCard.BottomContent gap={8}>
        <Column alignItems='center' bgColor='bg.infoSubtle' gap={8} px={12} py={8}>
          <Row justifyContent='space-between' width={'100%'}>
            <Typography color='text.tertiary' fontType='body2.regular'>
              신청일
            </Typography>
            <Typography color='text.info' fontType='body2.regular'>
              {applicationDate}
            </Typography>
          </Row>

          {status === PostCampaignStatus.EARNING_SUCCESS && (
            <Row justifyContent='space-between' width={'100%'}>
              <Typography color='text.tertiary' fontType='body2.regular'>
                적립 포인트
              </Typography>
              <Typography color='text.info' fontType='body2.regular'>
                {earningPoint}P
              </Typography>
            </Row>
          )}
        </Column>
      </PostCampaignCard.BottomContent>
    </PostCampaignCard>
  );
};
